import { render, staticRenderFns } from "./enum.vue?vue&type=template&id=45c580e8"
import script from "./enum.vue?vue&type=script&lang=ts"
export * from "./enum.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports